<template>
  <div class=" is-fullwidth">
    <div class="is-pulled-right">
      <button class="button is-warning is-pulled-right mb-2" @click="exportXLS()">Export to Excel</button>
    </div>
    <div class="is-pulled-right mr-4"><input class="input" v-model="search" placeholder="search orders ..."/></div>
        <p>This screen shows all orders that have been fully scanned for cutting. </p>
    
    
    
    <div class="notification is-info" v-if="loading == true">Loading orders ...</div>
    
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" v-if="loading == false">
    	<thead>
    		<tr>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Extras</th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th>Marker</th>
          <th>Fabric</th>
          <th>Cutting</th>
          <th>Makeup Location</th>
          <th width="125">&nbsp;</th>
        </tr>
    	</thead>
    	<tbody>
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>
            <OrderExtras :order="order"/>
          </td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td ><span v-if="order.marker_received == 1">Yes</span></td>
          <td ><span v-if="order.fabric_received == 1">Yes</span></td>
          <td style="display:none">{{ order.marker_received_date}}</td>
          <td style="display:none">{{ order.fabric_received_date}}</td>
          <td>{{ order.cutting_complete}}</td>
          <td>{{ order.makeup_location_name}}</td>
             <td style="padding:0px"><button class="button is-small is-info" @click="processOrder(order)" :disabled="working===true">Ready For Makeup</button></td>
			</tr>
    	</tbody>
    </table>

    <table class="" id="orderstableexcel" v-if="loading == false" style="display:none">
    	<thead>
    		<tr>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Extras</th>
          <th >Delivery
           
            
          </th>
          <th>Qty</th>
          <th>Marker</th>
          <th>Fabric</th>
          <th>Cutting</th>
          <th>Makeup Location</th>
          
        </tr>
    	</thead>
    	<tbody>
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>
            <OrderExtras :order="order"/>
          </td>
          <td>{{order.deliverydate_raw.slice(0,10)}}</td>
          <td>{{ order.total_qty }}</td>
          <td ><span v-if="order.marker_received == 1">Yes</span></td>
          <td ><span v-if="order.fabric_received == 1">Yes</span></td>
          <td style="display:none">{{ order.marker_received_date}}</td>
          <td style="display:none">{{ order.fabric_received_date}}</td>
          <td>{{ order.cutting_complete}}</td>
          <td>{{ order.makeup_location_name}}</td>
			</tr>
    	</tbody>
    </table>
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderExtras from '@/components/OrderExtras.vue';

import OrderMixin from "@/mixins/OrderMixin.js";

import XLSX from 'xlsx';

export default {
  components: {
    OrderExtras
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      cutting_rooms: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      cutting_location_id: '',
      limit:'',
      search: ''
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getCutSewInProgressOrders(this.accessToken, this.limit, this.order_by, "", 1, 0) // Last 2 fields are cutting complete, ready for makeup not completed
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      async processOrder(order) {
        this.working = true
        
        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             ready_for_cutsew_makeup: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            //console.log(response)
            order.ready_for_cutsew_makeup = 1
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },  
    
    async getRanges() {
        UtilityService.getSimpleApiData(this.accessToken, "ranges").then(
               response => this.ranges = response 
            );
      },
      async getCuttingRooms() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?cutting=1").then(
               response => this.cutting_rooms = response 
            );
      },
      exportXLS() {
        
        var wb = XLSX.utils.table_to_book(document.getElementById('orderstableexcel'), {sheet:"Sheet 1"});
        XLSX.writeFile(wb, 'Printing Overview.xlsx')

      },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.ready_for_cutsew_makeup == 0) 
            {
              return 1
            }
          })
          //let filteredOrders = this.orders

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           //this.getCuttingRooms();
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    'cutting_location_id'() {
      this.orders = []
      //localStorage.printing_location_id = this.selected_location_id
      this.getOrders();
    },
    
  }
}


</script>

